import { render, staticRenderFns } from "./SurveyPopup.vue?vue&type=template&id=6c353db6&"
import script from "./SurveyPopup.vue?vue&type=script&lang=js&"
export * from "./SurveyPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports